export interface DiagnosisCompletionGuardRow {
    confirmed: boolean;
    alreadyOnProfile: boolean;
}

/**
 * A diagnoses-enabled section has been addressed once the RN has saved any
 * diagnosis to this section. Profile and cross-section diagnoses are rendered
 * as locked/other rows (`alreadyOnProfile`) and do not count.
 */
export function hasDiagnosisAddedToThisSection(rows: DiagnosisCompletionGuardRow[]): boolean {
    return rows.some((d) => d.confirmed && !d.alreadyOnProfile);
}
